import { useDashData } from "../hooks/useDashData";
import PageHeader from "../components/layout/PageHeader";
import PlatformComparison from "../components/dashboard/PlatformComparison";
import { formatCompactINR } from "../lib/format";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Layers3 } from "lucide-react";

function PTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#1E293B] border border-white/10 rounded-lg p-3 text-xs space-y-1">
      <p className="font-medium text-white">{label}</p>
      {payload.map((p, i) => (
        <p key={i} className="text-slate-400">{p.name}: <span style={{ color: p.color }}>{formatCompactINR(p.value)}</span></p>
      ))}
    </div>
  );
}

export default function Platforms() {
  const { data: comparison } = useDashData("/analytics/platform-comparison");
  const { data: trends } = useDashData("/analytics/trends", { extra: { granularity: "daily" } });

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader title="Platform Comparison"
        subtitle="Meta Ads vs Google Ads — spend, efficiency & lead economics side by side" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PlatformComparison comparison={comparison} />
        <div className="rounded-xl bg-[#1E293B] border border-white/10 p-6">
          <div className="flex items-center gap-2 mb-5">
            <Layers3 className="w-5 h-5 text-[#38BDF8]" />
            <h2 className="font-display text-lg font-semibold">Daily Spend Split</h2>
          </div>
          <div className="h-[360px]">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={trends || []} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <defs>
                  <linearGradient id="metaG" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#38BDF8" stopOpacity={0.4} />
                    <stop offset="100%" stopColor="#38BDF8" stopOpacity={0} />
                  </linearGradient>
                  <linearGradient id="googleG" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#818CF8" stopOpacity={0.4} />
                    <stop offset="100%" stopColor="#818CF8" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid stroke="#334155" strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="date" tick={{ fill: "#64748B", fontSize: 10 }} axisLine={false} tickLine={false}
                  tickFormatter={(v) => String(v).slice(5)} minTickGap={20} />
                <YAxis tick={{ fill: "#64748B", fontSize: 10 }} axisLine={false} tickLine={false}
                  tickFormatter={(v) => `${(v / 1e5).toFixed(0)}L`} />
                <Tooltip content={<PTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
                <Area type="monotone" dataKey="meta_spend" name="Meta" stroke="#38BDF8" strokeWidth={2} fill="url(#metaG)" />
                <Area type="monotone" dataKey="google_spend" name="Google" stroke="#818CF8" strokeWidth={2} fill="url(#googleG)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
